  <template>
  <div class="page">
    <div class="header">
      <div class="flex_sb">
        <div class="flex">
          <van-image
            class="tx"
            round
            fit="cover"
            width="75px"
            height="75px"
            :src="headimgurl"
          />
          <p class="colw font15 ml30">{{ nick }}</p>
        </div>
      </div>
      <div class="cardinfo" v-if="havecard">
        <p class="card">{{ info.icType == 1 ? "普通卡" : "商务卡" }}</p>
        <div class="useinfo">
          <p>可用次数：{{ info.timesAvailable }}</p>
          <p>累计分配次数：{{ info.timesUsed }}</p>
          <p>剩余天数：{{ info.timesEndTimes }}</p>
        </div>
      </div>
    </div>
    <div class="content">
      <van-cell
        @click="toBind"
        title="绑定卡号"
        icon="coupon-o"
        is-link
        :value="binds"
      >
      </van-cell>
      <van-cell title="充值记录" icon="balance-list-o" @click="recharge" is-link>
      </van-cell>
      <van-cell title="使用记录" icon="todo-list-o" @click="useinfo" is-link>
      </van-cell>
      <van-cell title="数据上传" icon="back-top" @click="updata" is-link>
      </van-cell>
      <van-cell
        title="历史记录"
        icon="description"
        is-link
        @click="historylist"
      ></van-cell>
    </div>
    <p style="text-align:center"><a style="color:#61dec3" href="https://beian.miit.gov.cn/">闽ICP备20012852号-1</a></p>
  </div>
</template>
<script>
import API from "../utils/api";

export default {
  data() {
    return {
      info: {},
      binds: "绑定卡号",
      nick: '',
      havecard: false,
      headimgurl: "https://img01.yzcdn.cn/vant/cat.jpeg"
    };
  },
  watch: {},
  computed: {},
  methods: {
    getCardInfo() {
      if (!sessionStorage.getItem("phone")) {
        this.$router.push({ path: `login` });
        return;
      }
      if (sessionStorage.getItem("card")) {
        this.$get(`${API.cardInfo}?icCard=${sessionStorage.getItem("card")}`)
          .then((res) => {
            if (res.code == 200) {
              this.info = res.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    toBind() {
      if (sessionStorage.getItem("card")) {
        this.$toast("您已经绑定过卡了");
      } else {
        this.$router.push({ path: `bind` });
      }
    },
    recharge(){
      if(!sessionStorage.getItem("card")){
        this.$toast("请先绑定卡");
      }else{
        this.$router.push({ path: `recharge` });
      }
    },
    useinfo(){
      if(!sessionStorage.getItem("card")){
        this.$toast("请先绑定卡");
      }else{
        this.$router.push({ path: `useinfo` });
      }
    },
    updata(){
      if(!sessionStorage.getItem("card")){
        this.$toast("请先绑定卡");
      }else{
        this.$router.push({ path: `updata` });
      }
    },
    historylist(){
     if(!sessionStorage.getItem("card")){
        this.$toast("请先绑定卡");
      }else{
        this.$router.push({ path: `historylist` });
      }
    }
  },
  created() {},
  mounted() {
    this.getCardInfo();
    this.nick = sessionStorage.getItem("nick");
    this.headimgurl = sessionStorage.getItem("icon");
    if (sessionStorage.getItem("card")) {
      this.havecard = true
      this.binds = sessionStorage.getItem("card");
    }
  },
};
</script>
<style scoped>
.header {
  padding: 25px 30px 65px;
  background: #61dec3;
}
.flex_sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex {
  display: flex;
}
.tx {
  border: 2px solid #fff;
}
.colw {
  margin-left: 15px;
  color: #fff;
  font-size: 15px;
}
.cardinfo {
  width: 100%;
  margin-top: 10px;
  border-radius: 10px;
  background: #85e5d0;
  color: #fff;
  overflow: hidden;
}
.card {
  width: 80px;
  line-height: 24px;
  font-size: 16px;
  text-align: center;
  border-bottom-right-radius: 10px;
  white-space: nowrap;
  background-color: #fff;
  color: #fe8d77;
}
.useinfo {
  margin: 10px;
  margin-left: 40px;
  font-size: 14px;
  line-height: 24px;
}
.content{
  margin-top: -45px;
  border-radius: 10px;
  overflow: hidden;
}
.content .van-cell{
  line-height: 40px;
  font-size: 16px;
}
.content .van-cell .van-icon{
  line-height: 40px;
}
.van-cell .van-cell__left-icon{
  font-size: 20px;
  margin-right: 10px;
}
.van-cell:first-child .van-cell__left-icon{
  color: #b296ea;
}
.van-cell:nth-child(2) .van-cell__left-icon{
  color: #ff9bb6;
}
.van-cell:nth-child(3) .van-cell__left-icon{
  color: #89c5ff;
}
.van-cell:nth-child(4) .van-cell__left-icon{
  color: #ffbe90;
}
.van-cell:nth-child(5) .van-cell__left-icon{
  color: #8eedc7;
}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue